// How a reservation opens from the calendar, a per-user preference stored with the other
// venue manager preferences (users/<uid>/venuemanager/<customer>, appdata.userpreferences):
//   'modal' (Vanha) - the draggable modal over the calendar, the default
//   'panel' (Uusi)  - a side panel next to the calendar, which narrows and keeps the
//                     selected slot in view

export const RESERVATION_VIEW_KEY = 'reservationview'

// Below this window width there is no room for the calendar and a panel side by side.
export const PANEL_MIN_WINDOW_WIDTH = 992

// The stored choice, 'modal' unless the user has picked the panel.
export const reservationViewPreference = (userpreferences) =>
  userpreferences && userpreferences[RESERVATION_VIEW_KEY] === 'panel' ? 'panel' : 'modal'

// The view to use now: the panel only when chosen and the window is wide enough.
export const reservationViewOf = (userpreferences, windowWidth) =>
  reservationViewPreference(userpreferences) === 'panel' && windowWidth >= PANEL_MIN_WINDOW_WIDTH
    ? 'panel'
    : 'modal'

// Side panel width in px. The user can drag it wider or narrower; the width is remembered per
// browser (it depends on the screen, so it is not synced with the other preferences).
export const PANEL_MIN_WIDTH = 480
// at this width the form keeps its normal two-column layout instead of stacking
export const PANEL_WIDE_WIDTH = 900
const PANEL_WIDTH_STORAGE_KEY = 'reservationPanelWidth'

// Half the window by default, at least PANEL_MIN_WIDTH and at most 1200px.
export const defaultPanelWidth = (windowWidth) => Math.round(Math.min(1200, Math.max(PANEL_MIN_WIDTH, windowWidth * 0.5)))

// The calendar keeps at least 30% of the window.
export const clampPanelWidth = (width, windowWidth) =>
  Math.round(Math.max(PANEL_MIN_WIDTH, Math.min(width, windowWidth * 0.7)))

export const loadPanelWidth = () => {
  try {
    const width = parseInt(window.localStorage.getItem(PANEL_WIDTH_STORAGE_KEY), 10)
    return Number.isFinite(width) ? width : null
  } catch (error) {
    return null
  }
}

export const savePanelWidth = (width) => {
  try {
    window.localStorage.setItem(PANEL_WIDTH_STORAGE_KEY, String(width))
  } catch (error) {
    // storage unavailable (private window): the width just isn't remembered
  }
}
